import { FormEvent, PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  isValid?: boolean;
  onSubmit: () => void;
}>;

export const Form = ({ children, isValid = true, onSubmit }: Props) => {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (isValid) onSubmit();
  };

  return <form onSubmit={handleSubmit}>{children}</form>;
};
